export enum Tab {
    Manage = 'manage-existing-templates',
    Save = 'save-template'
}

export const TEST_IDS = {
    // Save Template Drawer
    SAVE_TEMPLATE_WRAPPER: 'save-template-wrapper',
    SAVE_TEMPLATE_V2_BUTTON: 'save-template-v2-button',
    UPDATE_TEMPLATE_BUTTON: 'save-template-button',
    CANCEL_SAVE_TEMPLATE_V2_BUTTON: 'cancel-save-template-v2-button',
    TEMPLATE_NAME_INPUT: 'template-name-input',
    TEMPLATE_DESCRIPTION_INPUT: 'template-description-input',
    NAME_TEMPLATE_SECTION: 'name-template-section',
    CONFIGURE_VEHICLES_SECTION: 'configure-vehicles-section',
    CONFIGURE_DYNAMIC_VEHICLES_SECTION: 'configure-dynamic-vehicles-section',
    CONFIGURE_TEMPLATE_SECTION: 'configure-template-section',
    TEMPLATE_YEAR_SELECT: 'template-year-select',
    TEMPLATE_TRIM_SELECT: 'template-trim-select',
    TEMPLATE_INVENTORY_TYPE_SELECT: 'template-inventory-type-select',
    TEMPLATE_MODEL_SELECT: 'template-model-select',
    TEMPLATE_CONFIGURATION_SELECT: 'template-configuration-select',
    TEMPLATE_MAKE_SELECT: 'template-make-select',
    DEAL_TEMPLATE_DRAWER: 'deal-template-drawer',
    OPEN_DRAWER_TO_SAVE_TEMPLATE: 'open-drawer-to-save-template',
    OPEN_DRAWER_TO_MANAGE_TEMPLATES: 'open-drawer-to-manage-templates',
    TEMPLATE_SAVE_DRAWER_TABS: 'template-save-drawer-tabs',
    TEMPLATE_SAVE_V2_LOADER: 'template-save-v2-loader',
    TEMPLATE_SAVE_SUCCESS_TOAST: 'template-save-success-toast',
    TEMPLATE_EXIST_WARNING_TOAST: 'template-exist-warning-toast',
    TEMPLATE_SAVE_ERROR_TOAST: 'template-save-error-toast',

    // Manage Templates Wrapper
    MANAGE_EXISTING_TEMPLATES_WRAPPER: 'manage-existing-templates-wrapper',
    DELETE_TEMPLATE_SUCCESS_TOAST: 'delete-template-success-toast',
    DELETE_TEMPLATE_ERROR_TOAST: 'delete-template-error-toast',
    UPDATE_TEMPLATE_SUCCESS_TOAST: 'update-template-success-toast',
    UPDATE_TEMPLATE_ERROR_TOAST: 'update-template-error-toast',
    CONFIRM_AUTO_APPLY_TEMPLATE: 'confirm-auto-apply-template',
    CANCEL_AUTO_APPLY_TEMPLATE: 'cancel-auto-apply-template',

    // Template List Table
    TEMPLATE_TABLE_WRAPPER: 'template-table-wrapper',
    DEAL_TEMPLATE_LIST: 'deal-template-list',
    AUTO_APPLY_SWITCH: 'auto-appy-switch',
    AUTO_APPLY_DISABLED_TOOLTIP: 'auto-apply-disabled-tooltip',
    MANUAL_APPLY_SWITCH: 'manual-appy-switch',
    DELETE_DEAL_TEMPLATE: (id: string) => `delete-deal-template-${id}`,
    EDIT_DEAL_TEMPLATE: (id: string) => `edit-deal-template-${id}`,
    TEMPLATE_MODIFIER: (id: string) => `template-modifier-${id}`,

    // Template Name/Description Cells
    TEMPLATE_NAME_POPOVER: 'template-name-popover',
    TEMPLATE_DESCRIPTION_POPOVER: 'template-description-popover',
    TEMPLATE_NAME: (id: string) => `template-name-${id}`,
    TEMPLATE_DESCRIPTION: (id: string) => `template-description-${id}`,

    // Deal Scenario Selector
    DEAL_SCENARIO_SELECTOR: 'deal-scenario-selector',
    DEAL_SCENARIO_LIST: 'deal-scenario-list',
    DEAL_SCENARIO_ITEM: 'deal-scenario-item',
    DEAL_SCENARIO_CHECKBOX: 'deal-scenario-checkbox',
    DEAL_SCENARIO_PRIMARY_BADGE: 'deal-scenario-primary-badge',

    // Template List Accordion
    ACCORDION_VEHICLE: (inventoryType: string) => `${inventoryType}-vehicle`,
    CONFIRM_DELETE_TEMPLATE: 'confirm-delete-template',
    CANCEL_DELETE_TEMPLATE: 'cancel-delete-template'
};

export enum InventoryType {
    All = 'All',
    New = 'New',
    CPO = 'CertifiedPreOwned',
    Used = 'Used'
}
